import React, { useEffect, useMemo, useState } from "react";
import {
  TableBody,
  TableCell,
  tableCellClasses,
  TableRow,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import SkeletonLoadingTableData from "./TableSkeleton/SkeletonLoadingTableData";
import Typography from "@mui/material/Typography";
import Tooltip from "@mui/material/Tooltip";
import { useTranslation } from "react-i18next";
import { getLanguage } from "../../utils/consts/localStorage";
import i18n from "../../utils/lanungeConfig";

function TableBodyData({
  filteredRows,
  loadingFilteredData,
  ordersHistoryDate,
}) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  // useEffect(() => {
  //   setOpen(false);
  //   setTimeout(() => setOpen(true), 10);
  // }, [i18n.language]);


  const formattedDate = (date) => {
    let newDate = "";
    if (date !== undefined) {
      newDate = new Date(
        `${date.slice(0, 4)}-${date.slice(4, 6)}-${date.slice(6, 8)}`
      ).toLocaleDateString("pl-PL");
    }
    return newDate;
  };

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({}));

  const memoizedRows = useMemo(() => {
    return filteredRows.map((row, index) => (
      <StyledTableRow key={index}>
        <StyledTableCell>{index + 1}</StyledTableCell>
        <StyledTableCell>
          <Typography style={{ fontSize: 18, fontWeight: "bolder" }}>
            {row.product}
          </Typography>
          {"\n"}
          <Typography style={{ color: "grey" }}>
            {row.ytransname}
          </Typography>{" "}
        </StyledTableCell>
        <StyledTableCell>
          <Typography style={{ fontSize: 16 }}>{row.recipient}</Typography>
        </StyledTableCell>
        <StyledTableCell>
          <Typography style={{ fontSize: 16 }}>{row.qty}</Typography>
        </StyledTableCell>
        <StyledTableCell>
          <Typography style={{ fontSize: 16 }}>{row.be}</Typography>
        </StyledTableCell>
        <StyledTableCell>
          {formattedDate(row.dateFrom) !== "Invalid Date" ? (
            <Tooltip
   
              title={
                <Typography>
                {t("historyDateChanges")} <br />
                
                 {ordersHistoryDate[row.orderId] && ordersHistoryDate[row.orderId][row.orderNumber]
                   ? ordersHistoryDate[row.orderId][row.orderNumber].map((date, i) => {
                      const splitDate = date.split(";");
                      return <div key={i}>{splitDate[0]}</div>
                 })
                  : ""}
              </Typography>
              }
              arrow
            >
              <Typography style={{ fontSize: 16 }}>
                {formattedDate(row.dateFrom)}
              </Typography>
            </Tooltip>
          ) : (
            ""
          )}
        </StyledTableCell>
      </StyledTableRow>
    ));
  }, [filteredRows, t]);

  return (
    <TableBody>
      {loadingFilteredData ? (
        <SkeletonLoadingTableData
          StyledTableCell={StyledTableCell}
          StyledTableRow={StyledTableRow}
        />
      ) : (
        memoizedRows
      )}
    </TableBody>
  );
}

export default TableBodyData;
